// extracted by mini-css-extract-plugin
module.exports = {"PageBreakManagement":"PageBreakManagement___1wSW9","title":"title___2pdm9"};